/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskPolicyApprovalConfig = {
  /**
   * Principal URNs that may approve held calls: specific users (user:...) or roles (role:...). Everyone is not allowed.
   */
  approvers: Array<string>;
};

/** @internal */
export const RiskPolicyApprovalConfig$inboundSchema: z.ZodMiniType<
  RiskPolicyApprovalConfig,
  unknown
> = z.object({
  approvers: z.array(z.string()),
});
/** @internal */
export type RiskPolicyApprovalConfig$Outbound = {
  approvers: Array<string>;
};

/** @internal */
export const RiskPolicyApprovalConfig$outboundSchema: z.ZodMiniType<
  RiskPolicyApprovalConfig$Outbound,
  RiskPolicyApprovalConfig
> = z.object({
  approvers: z.array(z.string()),
});

export function riskPolicyApprovalConfigToJSON(
  riskPolicyApprovalConfig: RiskPolicyApprovalConfig,
): string {
  return JSON.stringify(
    RiskPolicyApprovalConfig$outboundSchema.parse(riskPolicyApprovalConfig),
  );
}
export function riskPolicyApprovalConfigFromJSON(
  jsonString: string,
): SafeParseResult<RiskPolicyApprovalConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskPolicyApprovalConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskPolicyApprovalConfig' from JSON`,
  );
}
